<!-- CHAT AUTH -->
<span class="chat_auth cng-ico_lock" *ngIf="isAuthenticated"> </span>

<!-- CHAT REDIRECTION -->
<div class="chat_redirection" *ngIf="statsInfo['pageTitle']">
  <span [title]="formattedUA" [ngClass]="isMobile ? 'cng-ico_SMS' : 'cng-tuile_wallboard'" aria-hidden="true"></span>
  <span class="nodisplay">{{ formattedUA }}</span>
  <p title="{{ statsInfo['pageTitle'] }}" truncate>{{ statsInfo['pageTitle'] }}</p>
  <a [href]="statsInfo['pageUrl']" class="cng-ico_open_newwindow" target="_blank"></a>
</div>

<!-- CHAT DURATION -->
<time *ngIf="interactionDate > 0" class="chat_duration cng-ico_label_time">
  {{ interactionDate | elapsedTime }}
</time>

<!-- CHAT DURATION DETAILS -->
<div class="chat_duration-details cng-ico_info">
  <div class="content">
    <time *ngIf="timerStatsInfo.get('timeOnCurrentPage')">
      {{ timerStatsInfo.get('timeOnCurrentPage') | localizedDate: 'm' }}
      {{ 'agent:contact.workspace.chat.visitor_info.time_on_this_page' | translate }}
    </time>
    <time *ngIf="timerStatsInfo.get('timeOnTheWebSite')">
      {{ timerStatsInfo.get('timeOnTheWebSite') | localizedDate: 'm' }}
      {{ 'agent:contact.workspace.chat.visitor_info.time_on_the_website' | translate }}
    </time>
    <span>{{ statsInfo['numberOfPageView'] }} {{ 'agent:contact.workspace.chat.visitor_info.page_viewed' | translate }}</span
    ><span>{{ statsInfo['numberOfVisit'] }} {{ 'agent:contact.workspace.chat.visitor_info.number_of_visit' | translate }}</span>
  </div>
</div>
